function getLinking() {
  var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  return config;
}
function normalizeLinkingConfig(config) {
  var defaultPrefixes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  var _ref;
  var merged = [
    ...defaultPrefixes,
    ...getSchemePrefixes(config === null || config === void 0 ? void 0 : config.scheme),
    ...(_ref = config === null || config === void 0 ? void 0 : config.prefixes) !== null && _ref !== void 0 ? _ref : []
  ];
  return {
    prefixes: dedupe(merged),
    filter: config === null || config === void 0 ? void 0 : config.filter
  };
}
function getSchemePrefixes(scheme) {
  var schemes = Array.isArray(scheme) ? scheme : scheme ? [
    scheme
  ] : [];
  return schemes.flatMap(function(value) {
    var normalized = value.replace(/:\/+$/, "");
    return [
      `${normalized}://`,
      `${normalized}:///`
    ];
  });
}
function dedupe(values) {
  return [
    ...new Set(values.filter(Boolean))
  ];
}
export {
  getLinking,
  normalizeLinkingConfig
};
//# sourceMappingURL=getLinking.js.map
